var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders,
    transitions = _ref.transitions;
  return {
    categoriesContainerPadding: spacing.small,
    categoryContainerMargin: spacing.xSmall,
    categoryContainerPadding: spacing.small,
    pillMargin: spacing.small,
    categoryContainerBackground: colors.porcelain,
    categoryMargin: spacing.xSmall,
    categoryBackground: colors.white,
    emptyCategoryColor: colors.tiara,
    emptyCategoryBorderColor: colors.tiara,
    emptyCategoryBorderRadius: borders.radiusMedium,
    emptyCategoryBorderWidth: borders.widthMedium,
    filledCategoryBorderColor: colors.tiara,
    filledCategoryBorderWidth: borders.widthMedium,
    filledCategoryBorderRadius: borders.radiusMedium,
    focusBorderColor: colors.brand,
    focusBorderWidth: borders.widthSmall,
    popoverTriggerBeforeTransition: "all ".concat(transitions.duration)
  };
};
export default generateComponentTheme;